import styled from "styled-components";
import makeLimitedList from "~/shared/util/makeLimitedList";
import Tag from "./Tag";
import UnstyledList from "./UnstyledList";

const RemainderItem = styled(UnstyledList.Item)`
  color: var(--orange);
`;

interface TagListProps extends React.HTMLAttributes<HTMLUListElement> {
  tags: string[];
  limit: number;
  compact?: boolean;
  separator?: string;
}

const TagList = ({ tags = [], className, limit, compact, separator = " |", ...rest }: TagListProps) => {
  if (tags.length < 1) return null;

  const { list, remainder } = makeLimitedList(tags, limit);

  return (
    <UnstyledList {...rest} className={className} data-taglist>
      {list.map((tag, i) => (
        <UnstyledList.Item key={tag}>
          {compact ? (
            <>
              {tag}
              {i < list.length - 1 || remainder ? (
                <span
                  style={{
                    ...(!/,/.test(separator) ? { color: "var(--border-gray)" } : {}),
                  }}
                >
                  {separator}&nbsp;
                </span>
              ) : null}
            </>
          ) : (
            <Tag text={tag} small grayBackground remove={false} />
          )}
        </UnstyledList.Item>
      ))}
      {remainder ? <RemainderItem>+ {remainder}</RemainderItem> : null}
    </UnstyledList>
  );
};

export default TagList;
